import axios from 'axios';
import config from '../config'; // Import your config file

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: config.apiBaseUrl, // Use the base URL from your config
  timeout: 10000, // Optional: Set a timeout for requests
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (request) => {
    // Check if UAT mode is enabled
    const isUATMode = config.isUAT; // Call the dynamic UAT function

    if (isUATMode) {
      const url = new URL(request.url, window.location.origin);
      url.searchParams.set('uat', 'true');
      request.url = url.toString();
    }

    return request;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

export default axiosInstance;